'use client';

import getImages from '@/actions/projects/getImages';
import ArrowRight from '@/assets/svg/ArrowRight';
import { VideoPlayer } from '@/components/ui/video-player';
import { StrapiImage } from '@/types/img';
import { Project } from '@/types/project';
import { Service } from '@/types/service';
import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useState } from 'react';

interface Props {
  project: Project;
  button?: string;
  locale: string;
  slug: string;
}

export default function ImagesSection({
  project,
  button,
  locale,
  slug,
}: Props) {
  const [images, setImages] = useState<
    {
      id: number;
      indexId: number;
      img: StrapiImage;
      media: 'image' | 'video';
    }[]
  >([]);

  useEffect(() => {
    getImages({
      locale: locale,
      slug,
      baseUrl: true,
    }).then((res) => {
      if (res.data?.data) {
        let imgArr = res.data.data[0]?.images;
        if (!!imgArr?.length) {
          const sortedArr = imgArr.sort((a, b) => a.indexId - b.indexId);
          setImages(sortedArr);
        }
      }
    });
  }, [project]);

  return (
    <div>
      <section className='w-full object-cover masonry-gallery-full sm:hidden'>
        {images.map((i) => (
          <>
            {i?.media === 'video' ? (
              // <video
              //   src={i.img?.url}
              //   autoPlay
              //   loop
              //   muted
              //   playsInline
              //   preload='auto'
              //   onContextMenu={(e) => e.preventDefault()}
              //   controls
              //   className='object-cover masonry-item-full rounded-[20px]'
              // />
              <VideoPlayer
                src={
                  typeof i.img?.url === 'string'
                    ? i.img.url
                    : (i.img?.url as { src?: string })?.src ?? ''
                }
                // width={i.img.width}
                // height={i.img.height}
              />
            ) : i?.img?.url && i?.img?.width && i?.img?.height ? (
              <Image
                src={i.img.url}
                width={i.img.width}
                height={i.img.height}
                className='object-cover masonry-item-full rounded-[20px]'
                alt=''
                unoptimized
                onContextMenu={(e) => e.preventDefault()}
              />
            ) : null}
          </>
        ))}
      </section>
      <section className='w-full px-4 py-4 masonry-gallery-full-mobile hidden sm:grid'>
        {images.map((i) => (
          <>
            {i?.media === 'video' ? (
              <video
                src={
                  typeof i.img?.url === 'string'
                    ? i.img.url
                    : (i.img?.url as { src?: string })?.src ?? ''
                }
                autoPlay
                loop
                muted
                playsInline
                preload='auto'
                className='object-cover masonry-item-full-mobile rounded-[20px]'
              />
            ) : i?.img?.url && i?.img?.width && i?.img?.height ? (
              <Image
                src={i.img.url}
                width={i.img.width}
                height={i.img.height}
                className='object-cover masonry-item-full-mobile rounded-[20px]'
                alt=''
                unoptimized
                onContextMenu={(e) => e.preventDefault()}
              />
            ) : null}
          </>
        ))}
      </section>
    </div>
  );
}
